import { useMemo } from "react";
import { ClipsSidePanel } from "@src/components/web/ClipsSidePanel.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { Slot, Stack, useLocalSearchParams } from "expo-router";
import { useCameraDetailsData } from "@src/features/cameras/hooks/useCameraDetailsData";
import { getTimezoneFromAlarmDetail } from "@src/features/alarms/utils/alarm-utils";

export default function ClipsRoutesWebLayout() {
  const params = useLocalSearchParams<{ siteId?: string; cameraKey?: string }>();
  const siteId = params.siteId;
  const cameraKey = params.cameraKey;
  const { alarmDetail } = useCameraDetailsData();
  const timezone = useMemo(
    () => getTimezoneFromAlarmDetail(alarmDetail) || Intl.DateTimeFormat().resolvedOptions().timeZone,
    [alarmDetail],
  );

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout
        rightPanel={
          cameraKey && siteId ? <ClipsSidePanel cameraKey={cameraKey} siteId={siteId} timezone={timezone} /> : null
        }
      >
        <Slot />
      </WebLayout>
    </>
  );
}
